<template>
    <div>
        <div id="content">
            <div class="search-bar">
                <form action>
                    <input
                        type="search"
                        placeholder="Hasta ismini yazarak aratabilirsiniz"
                        v-model="searchName"
                    />
                    <p>veya</p>
                    <input
                        type="search"
                        placeholder="Tanı yazarak aratabilirsiniz"
                        v-model="searchTani"
                    />
                    <button
                        class="btn btn-blue"
                        @click.prevent="searchTaburcular"
                    >
                        <i class="fa fa fa-search"></i> Taburcularda Ara
                    </button>
                </form>
            </div>
            <div class="taburcu-content">
                <div class="card card-fw">
                    <p class="header bg-blue">
                        Arama Sonuçları
                        {{
                            patients.length
                                ? "(" + results.length + " sonuç)"
                                : ""
                        }}
                    </p>
                    <ul class="patients">
                        <template v-for="s in patients">
                            <div class="yeri" :key="s.id">
                                {{ s.yeri }}
                            </div>
                            <li
                                v-for="p in s.patients"
                                :key="p.id"
                                @click="
                                    $router.push(
                                        '/patients/' + p.path + '/' + p.id
                                    )
                                "
                            >
                                <div class="col-name">
                                    {{ p.name }}
                                    <br />
                                    <span class="tanilar">{{ p.tanilar }}</span>
                                </div>
                                <div class="yatis-cikis">
                                    {{ p.yatis | moment("DD.MM.YYYY") }}
                                </div>
                                <div class="yatis-cikis">
                                    {{ p.taburcudate | moment("DD.MM.YYYY") }}
                                </div>
                            </li>
                        </template>
                    </ul>
                    <div class="empty" v-if="!results.length">
                        <div class="small-empty">
                            <i class="fa fa-info-circle fa-3x"></i>
                            <span>Hasta bulunamadı</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
export default {
    name: "Arsiv",
    data() {
        return {
            searchName: "",
            searchTani: "",
            results: [],
        };
    },
    computed: {
        patients() {
            var result = _.chain(this.results)
                .groupBy("yeri")
                .map((value, key) => ({
                    yeri: this.$store.getters.getServis(key),
                    patients: value,
                }))
                .value();
            return result;
        },

        patientsYD() {
            return this.patientListYD;
        },
    },
    methods: {
        searchTaburcular() {
            if (this.searchName != "" || this.searchTani != "") {
                let self = this;
                this.$http
                    .get(
                        "api/taburcu.php?sname=" +
                            this.searchName +
                            "&stani=" +
                            this.searchTani
                    )
                    .then(function (response) {
                        self.results = response.data.data;
                    });
            } else {
                this.$snotify.warning(
                    "Aramak için en az bir alanı doldurmalısınız"
                );
            }
        },
    },
    created() {
        //this.getTaburcular();
    },
};
</script>

<style lang="scss">
.taburcu-content {
    display: flex;
    ul.patients li {
        border-left: 0 !important;
        padding-left: 3px;
        .col-name {
            width: calc(100% - 160px) !important;
        }
        .yatis-cikis {
            vertical-align: top;
            text-align: center;
            display: inline-block;
            padding: 10px 0;
            width: 80px;
        }
    }
}
.search-bar {
    flex: 1 1 100%;
    padding: 15px 15px 0 15px;
    input {
        width: 100%;
        font-size: 16px !important;
        margin: 5px 0;
    }
    p {
        padding: 5px;
    }
    button {
        margin: 10px 0 !important;
    }
}

@media (max-width: 1280px) {
    .taburcu-content {
        flex-direction: column;
    }
}
</style>